import { render } from "./remoteLogin.vue?vue&type=template&id=3e33662f&scoped=true"
import script from "./remoteLogin.vue?vue&type=script&lang=js"
export * from "./remoteLogin.vue?vue&type=script&lang=js"

import "./remoteLogin.vue?vue&type=style&index=0&id=3e33662f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3e33662f"

export default script